import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.foundationAccrual
)

export const selectIsFoundationAccrualModalOpen = createSelector(
    baseSelector,
    (state) => state.isFoundationAccrualModalOpen
)

export const selectOnAccrual = createSelector(
    baseSelector,
    (state) => state.onAccrual
)

export const selectSelectedFoundationAccrualProgram = createSelector(
    baseSelector,
    (state) => state.selectedProgram
)
